<!-- <p>user-follower-view works!</p> -->

<div class="wrapper">

    <!-- Aside End -->
    <main class="middle-content" >
        <!-- Page Title Start -->
        <div class="page_title_block">
            <h1 class="page_title">View Following</h1>
        </div>
        <!-- Page Title End -->
        <div class="content-section">
            <div class="order-view mt30 max-WT-700 mrgn-0-auto">
                <div class="main-block-innner mb40 mt40">
                    <div class="add-store-block1 input-style" >
                        <div class="form-group row ">
                            <label class="col-md-3" >Following Id</label>
                            <label class="col-md-1"> : </label>
                            <label class="col-md-8"> {{veiwfollowing?.userId?._id}} </label>
                        </div>
                        <div class="form-group row ">
                            <label class="col-md-3">Name</label>
                            <label class="col-md-1"> : </label>
                            <label class="col-md-8"> {{veiwfollowing?.userId?.fullName || '--'}} </label>
                        </div>
                        <div class="form-group row ">
                            <label class="col-md-3">Username</label>
                            <label class="col-md-1"> : </label>
                            <label class="col-md-8"> {{veiwfollowing?.userId?.userName || '--'}} </label>
                        </div>
                        <div class="form-group row ">
                            <label class="col-md-3">Email</label>
                            <label class="col-md-1"> : </label>
                            <label class="col-md-8"> {{veiwfollowing?.userId?.email || '--'}} </label>
                        </div>
                        <div class="form-group row ">
                            <label class="col-md-3">Phone Number </label>
                            <label class="col-md-1"> : </label>
                            <label class="col-md-8">{{veiwfollowing?.userId?.countryCode}}  {{veiwfollowing?.userId?.phoneNumber || '--'}} </label>
                        </div>

                        <div class="form-group row ">
                            <label class="col-md-3">Request Status</label>
                            <label class="col-md-1"> : </label>
                            <label class="col-md-8"> {{(veiwfollowing?.request | titlecase) || '--'}} </label>
                        </div>
                        <div class="form-group row ">
                            <label class="col-md-3" >Created Date & Time</label>
                            <label class="col-md-1"> : </label>
                            <label class="col-md-8"> {{veiwfollowing?.createdAt | date:'medium'}}</label>
                        </div>
               
                        <div class="text-center mt40">
                            <!-- <a href="javascript:void(0)" class="btn btn-theme  max-WT-200 font-100 btn-green mr-2" (click)="saveAboutUS()">Update</a> -->
                            <a href="javascript:void(0)" class="btn btn-theme  max-WT-200 font-100 btn-grey ml5" (click)="listfollower(veiwfollowing?.followerId,'user-following')">Back</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </main>
    <!-- Middle Content End -->
</div>
